"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceLimits = void 0;
class InsuranceLimits {
    constructor(data) {
        this.perConveyanceLimit = data.perConveyanceLimit;
        this.anyOneOccurrenceLimit = data.anyOneOccurrenceLimit;
        this.desiredDeductible = data.desiredDeductible;
        this.isScheduledTerminalCoverageRequired =
            data.isScheduledTerminalCoverageRequired;
        this.scheduledTerminals = data.scheduledTerminals;
        this.isUnscheduledLocationsCoverageRequired =
            data.isUnscheduledLocationsCoverageRequired;
        this.unscheduledLocationsInfo = data.unscheduledLocationsInfo;
    }
    static empty() {
        const data = {
            perConveyanceLimit: {
                currency: "USD",
                value: null
            },
            anyOneOccurrenceLimit: {
                currency: "USD",
                value: null
            },
            desiredDeductible: "",
            isScheduledTerminalCoverageRequired: null,
            scheduledTerminals: [],
            isUnscheduledLocationsCoverageRequired: null,
            unscheduledLocationsInfo: ""
        };
        return new InsuranceLimits(data);
    }
    static fromObj(data) {
        if (!data)
            return InsuranceLimits.empty();
        return new InsuranceLimits({
            perConveyanceLimit: data.perConveyanceLimit,
            anyOneOccurrenceLimit: data.anyOneOccurrenceLimit,
            desiredDeductible: data.desiredDeductible,
            isScheduledTerminalCoverageRequired: data.isScheduledTerminalCoverageRequired,
            scheduledTerminals: data.scheduledTerminals,
            isUnscheduledLocationsCoverageRequired: data.isUnscheduledLocationsCoverageRequired,
            unscheduledLocationsInfo: data.unscheduledLocationsInfo
        });
    }
}
exports.InsuranceLimits = InsuranceLimits;
//# sourceMappingURL=insuranceLimits.class.js.map